import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image/Apple.svg")